import superagentPromise from 'superagent-promise';
import _superagent from 'superagent';

const superagent = superagentPromise(_superagent, global.Promise);

let API_ROOT = 'https://dearinvite.com/api';
if(window.location.href.indexOf('localhost') !== -1) {
  API_ROOT = 'http://localhost:5000/api';
}else if(window.location.href.indexOf('10.0.0.35') !== -1) {
  API_ROOT = 'http://10.0.0.35:3000/api';
}
console.log(API_ROOT);

const encode = encodeURIComponent;
const responseBody = res => res.body;

let token = null;
const tokenPlugin = req => {
  if (token) {
    req.set('authorization', `Token ${token}`);
    req.set('Content-Type', 'application/json');
  }
}

const requests = {
  del: url =>
    superagent.del(`${API_ROOT}${url}`).use(tokenPlugin).then(responseBody),
  get: url =>
    superagent.get(`${API_ROOT}${url}`).use(tokenPlugin).then(responseBody),
  put: (url, body) =>
    superagent.put(`${API_ROOT}${url}`, body).use(tokenPlugin).then(responseBody),
  post: (url, body) =>
    superagent.post(`${API_ROOT}${url}`, body).use(tokenPlugin).then(responseBody)
};

const Auth = {
  login: (email, pass) => 
    requests.post('/auth/login', { email, pass }),
  current: () => 
    requests.get('/auth/me'),
  register: (name, email, pass) =>
    requests.post('/users', { name, email, pass }),
};

const Trips = {
  getAll: () => requests.get('/trips')
};


const Sites = {
  getAll: () => requests.get('/sites'),
  getSingleSite: id => requests.get(`/sites/${id}`),
  createSite: siteData => requests.post('/sites', siteData),
  updateSite: siteData => requests.put(`/sites/${siteData.id}`, siteData),
  checkAvailability: (name, template) => requests.post('/sites/check', {name, template}),
};

const Columns = {
  getAll: tableId => requests.get(`/tables/${tableId}/columns`),
  getSingleColumn: (tableId, columnId) => requests.get(`/tables/${tableId}/columns/${columnId}`),
  createColumn: (tableId, columnData) => requests.post(`/tables/${tableId}/columns`, columnData),
  updateColumn: (tableId, columnId, columnData) => requests.put(`/tables/${tableId}/columns/${columnId}`, columnData),
  deleteColumn: (tableId, columnId) => requests.del(`/tables/${tableId}/columns/${columnId}`),
};

const Tables = {
  getAll: () => requests.get('/tables'),
  getSingleTable: (tableId) => requests.get(`/tables/${tableId}`),
  createTable: tableData => requests.post('/tables', tableData),
  updateTable: (tableId, tableData) => requests.put(`/tables/${tableId}`, tableData),
};

const Data = {
  getAll: (tableId) => requests.get(`/tables/${tableId}/data`),
  getSingleRow: (tableId, rowId) => requests.get(`/tables/${tableId}/data/${rowId}`),
  createRow: (tableId, rowData) => requests.post(`/tables/${tableId}/data`, rowData),
  updateRow: (tableId, rowId, rowData) => requests.put(`/tables/${tableId}/data/${rowId}`, rowData),
  deleteRow: (tableId, rowId) => requests.del(`/tables/${tableId}/data/${rowId}`),
  search: (tableId, searchObj) => requests.post(`/tables/${tableId}/search`, searchObj),
};

const Applications = {
  submit: (data) => 
    requests.post('/applications', data)
};

export default {
  Auth,
  Trips,
  Sites,
  Tables,
  Columns,
  Data,
  Applications,
  setToken: _token => { token = _token; }
};
